import { AbstractControl, ValidatorFn } from '@angular/forms';

export function minDate(minDate: Date): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;

    const dateValue = new Date(value);
    if (isNaN(dateValue.getTime()))
      return {
        invalidDate: true
      };

    if (dateValue < minDate)
      return {
        minDate: true
      };
  };
}
